import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { CourseEntity } from 'src/entities/Course.entity';
import { CourseMasterError } from 'src/utils/courseMasterError';

import { sourceLabel } from './AddCoursesDialog';
import { courseLabel } from './courseMasterUtils';

type Prompt = Extract<CourseMasterError, { code: 'route_source_required' }>;
type Props = { prompt: Prompt | null; courses: CourseEntity[]; onChoose: (timetableId: number) => void; onClose: () => void };

export default function RouteSourceDialog({ prompt, courses, onChoose, onClose }: Props) {
  const [value, setValue] = useState<number | ''>('');
  // 別のコース・別の候補で開き直したら前の選択を持ち越さない
  useEffect(() => { setValue(''); }, [prompt]);
  const course = courses.find((c) => c.id === prompt?.courseId);
  const valid = value !== '' && Boolean(prompt?.sources.some((s) => s.timetableId === value));
  return (
    <Dialog open={Boolean(prompt)} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: 16 }}>{course ? courseLabel(course) : 'コース'} の並びのコピー元を選んでください</DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: 13, color: 'text.secondary', mb: 1 }}>{prompt?.message}</Typography>
        <RadioGroup value={value} onChange={(e) => setValue(Number(e.target.value))}>
          {prompt?.sources.map((s) => <FormControlLabel key={s.timetableId} value={s.timetableId} control={<Radio size="small" />} label={sourceLabel(s)} />)}
        </RadioGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>キャンセル</Button>
        <Button variant="contained" disableElevation disabled={!valid} onClick={() => { if (value !== '') onChoose(value); }}>この並びをコピーして保存</Button>
      </DialogActions>
    </Dialog>
  );
}
